import ClaveBienvenida from './../../components/organisms/ClaveBienvenida';
import './clave.scss';

const Clave = () => {
  return (
    <div role="main" data-landmark-index="4">
      <ClaveBienvenida />
    </div>
  )
}
export default Clave